/**
 * @param {...function} fns
 * @returns {function}
 */
function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduce(function (result, x) {
    return function () {
      return result(x.apply(undefined, arguments));
    };
  });
}

export default compose;